import { render, staticRenderFns } from "./manageGoods1.vue?vue&type=template&id=15ed28ae&scoped=true&"
import script from "./manageGoods1.vue?vue&type=script&lang=js&"
export * from "./manageGoods1.vue?vue&type=script&lang=js&"
import style0 from "./manageGoods1.vue?vue&type=style&index=0&id=15ed28ae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ed28ae",
  null
  
)

export default component.exports